<template>
  <div ref="container">
    <img ref="img" :src="imgSrc">
    <span>{{ nw }} x {{ nh }}</span>
    <canvas ref="canvas"></canvas>
  </div>
</template>
<script>
export default {
    props: {
        value: Object,
        imgSrc: String,
    },
    data() {
        return {
            w: 0,
            h: 0,
            nw: 0,
            nh: 0,
        };
    },
    methods: {
        clamp(n, min, max) {
            if (n < min)
                n = min;
            else if (n > max)
                n = max;
            return n;
        },
        // canvas related functions
        init() {
            let canvas = this.$refs.canvas;
            let container = this.$refs.container;
            let img = this.$refs.img;
            this.nw = img.naturalWidth;
            this.nh = img.naturalHeight;
            this.w = canvas.width = img.width;
            this.h = canvas.height = img.height;
            this.isdown = false;
            this.ctx.strokeStyle = "rgba(170,170,255,1)";
            this.ctx.fillStyle = "rgba(170,170,255,0.5)";
            this.ctx.lineWidth = 1;
            this.draw();
        },
        draw() {
            if (this.value) {
                this.ctx.clearRect(0, 0, this.w, this.h);
                this.ctx.beginPath();
                this.ctx.moveTo(this.x1, this.y1);
                this.ctx.lineTo(this.x2, this.y1);
                this.ctx.lineTo(this.x2, this.y2);
                this.ctx.lineTo(this.x1, this.y2);
                this.ctx.lineTo(this.x1, this.y1);
                this.ctx.stroke();
                this.ctx.fill();
            }
        },
        // mouse event functions
        onmousedown(event) {
            if (!this.isdown) {
                this.isdown = true;
                this.x1 = this.x2 = event.offsetX;
                this.y1 = this.y2 = event.offsetY;
            }
        },
        onmousemove(event) {
            if (this.isdown) {
                this.x2 = event.offsetX;
                this.y2 = event.offsetY;
            }
        },
        onmouseup(event) {
            if (this.isdown) {
                this.x2 = event.offsetX;
                this.y2 = event.offsetY;
                this.isdown = false;
            }
        },
    },
    mounted() {
        let canvas = this.$refs.canvas;
        let img = this.$refs.img;
        this.ctx = canvas.getContext("2d");
        canvas.onmousedown = this.onmousedown;
        canvas.onmousemove = this.onmousemove;
        canvas.onmouseup = this.onmouseup;
        canvas.onmouseleave = this.onmouseup;
        img.onload = this.init;
        this.init();
    },
    computed: {
        x1: {
            get: function() {
                return Math.round(this.clamp(this.value.x1, 0, this.nw) * (this.w / this.nw));
            },
            set: function(v) {
                this.value.x1 = Math.round(this.clamp(v, 0, this.w) * (this.nw/this.w));
            }
        },
        y1: {
            get: function() {
                return Math.round(this.clamp(this.value.y1, 0, this.nh) * (this.h / this.nh));
            },
            set: function(v) {
                this.value.y1 = Math.round(this.clamp(v, 0, this.h) * (this.nh/this.h));
            }
        },
        x2: {
            get: function() {
                return Math.round(this.clamp(this.value.x2, 0, this.nw) * (this.w / this.nw));
            },
            set: function(v) {
                this.value.x2 = Math.round(this.clamp(v, 0, this.w) * (this.nw/this.w));
            }
        },
        y2: {
            get: function() {
                return Math.round(this.clamp(this.value.y2, 0, this.nh) * (this.h / this.nh));
            },
            set: function(v) {
                this.value.y2 = Math.round(this.clamp(v, 0, this.h) * (this.nh/this.h));
            }
        },
    },
    watch: {
        value: {
            handler: function() {
                this.draw();
            },
            deep: true,
        }
    },
};
</script>
<style scoped>
div {
    display: inline-flex;
    flex-direction: column;
    position: relative;
    user-select: none;
}
img {
    user-select: none;
    border: solid 1px black;
    width: 100%;
    height: auto;
}
canvas {
    position: absolute;
    left: 1px;
    top: 1px;
}
</style>

